import { render, staticRenderFns } from "./ProductsFooter.vue?vue&type=template&id=7c3560a9&"
import script from "./ProductsFooter.vue?vue&type=script&lang=js&"
export * from "./ProductsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports